import { getAxiosInstance } from '@/services/axiosConfig';

const axiosInstance = getAxiosInstance();

export const getFalModel = async (falUrl: string) => {
  const res = await axiosInstance.post<{ name: string; schema: Record<string, any>; version: string }>(
    `/v1/models/fal/model`,
    { url: falUrl },
  );
  return res.data;
};
